import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  slotContainer: {
    width: '100%',
    maxWidth: 400,
    margin: 'auto',
    marginTop: 24,
    display: 'flex',
    flexDirection: 'column',
    rowGap: 16,
  },
  button: {
    width: '100%',
  },
}))

export default useStyles
